<template>
  <div class="row">
    <AlarmBorder height="28px" :status="item.state"/>
    <span class="timestamp a-text grayLight--text">{{ item.timestamp }}</span>
    <span class="area a-text">{{ item.area }}</span>
    <span class="a-text mr-1 name">{{ item.name }}</span>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
          class="description a-text dark--text description"
          >{{ item.description }}</span
        >
      </template>
      <span>{{ item.description }}</span>
    </v-tooltip>
    <span class="a-text state">{{ item.detailedState }}</span>
  </div>
</template>

<script>
import AlarmBorder from "@/components/Alarms/AlarmBorder.vue"

export default {
  components:{
    AlarmBorder
  },
  props: {
    item: Object,
  },
  data() {
    return {
      colors: [],
      icon: ["report", "error", "warning"],
    };
  },
  mounted() {
    this.getColors();
  },
  methods: {
    getColors() {
      this.colors = [
        this.$vuetify.theme.themes.light.accent,
        this.$vuetify.theme.themes.light.warning,
        this.$vuetify.theme.themes.light.error,
      ];
    },
  },
};
</script>

<style scoped lang="scss">
.row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: $light;
  height: 33px;
  border-radius: 5px;
  margin: 3px 0px;
  padding: 0px 10px 0px 0px;
}
.state {
  width: 100px;
  text-align: end;
}
.timestamp {
  width: 180px;
  text-align: start;
}
.area {
  width: 150px;
  text-align: start;
}
.name {
  width: 100px;
  text-align: start;
}
.description {
  width: 205px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: start;
}
</style>